module.exports = __webpack_public_path__ + "img/reference-dqs-consulting.764eb79a.webp";